import DemoPano from './demo-pano'
import DemoCubePano from './demo-cube-pano'
import DemoVideoPano from './demo-video-pano'
import DemoScene from './demo-scene'
import DemoTour from './demo-tour'

const pages = [
  DemoPano,
  DemoCubePano,
  DemoVideoPano,
  DemoScene,
  DemoTour
]

export { pages }



// WEBPACK FOOTER //
// ./demos/pages/index.js